class AcademyCourseContainerCtrl {
  courseTrack: any;
  user: any;
  useRedesign: boolean;
  useRedesignCatalog: boolean;
}

export default AcademyCourseContainerCtrl;
